module.exports = __webpack_public_path__ + "static/039-d0c09db77a2150460b68cbf48311dcb6.jpg";